import { COUCH_SEEK_BACKWARDS, COUCH_SEEK_FORWARDS } from '@videotools/js/events/enum.js';

export const events = {
	// All
	HOTKEY_SHOW_OVERLAY:           'hotkey:show-overlay',
	HOTKEY_TOGGLE_OVERLAY:         'hotkey:toggle-overlay',
	HOTKEY_TOGGLE_PLAY:            'hotkey:toggle-play',
	HOTKEY_PLAY_NEXT_TAG:          'hotkey:play-next-tag',
	HOTKEY_PLAY_PREVIOUS_TAG:      'hotkey:play-previous-tag',
	HOTKEY_TOGGLE_MUTE:            'hotkey:toggle-mute',
	HOTKEY_RESTART_PLAYER:         'hotkey:restart-player',
	HOTKEY_TOGGLE_FULLSCREEN:      'hotkey:toggle-fullscreen',
	HOTKEY_NEXT_TAB:               'hotkey:next-tab',
	HOTKEY_PREVIOUS_TAB:           'hotkey:previous-tab',
	HOTKEY_SEEK_BACKWARDS_TEN_SEC: 'hotkey:seek-backwards-ten-sec',
	HOTKEY_SEEK_FORWARDS_TEN_SEC:  'hotkey:seek-forwards-ten-sec',

	// View mode
	HOTKEY_VOLUME_UP:   'hotkey:volume-up',
	HOTKEY_VOLUME_DOWN: 'hotkey:volume-down',

	// SmartTV
	HOTKEY_TV_BACK: 'hotkey:tv-back',

	// Analysis
	HOTKEY_SPEED_UP:        'hotkey:speed-up',
	HOTKEY_SPEED_DOWN:      'hotkey:speed-down',
	HOTKEY_IN_POINT:        'hotkey:in-point',
	HOTKEY_OUT_POINT:       'hotkey:out-point',
	HOTKEY_PLAY_LAST_TAG:   'hotkey:play-last-tag',
	HOTKEY_EDIT_NEWEST_TAG: 'hotkey:edit-newest-tag',

	// Couch
	HOTKEY_COUCH_SEEK_BACKWARDS: COUCH_SEEK_BACKWARDS,
	HOTKEY_COUCH_SEEK_FORWARDS:  COUCH_SEEK_FORWARDS,

	// Mixed
	HOTKEY_SEEK_BACKWARDS_ONE_SEC:   'hotkey:seek-backwards-one-sec',
	HOTKEY_SEEK_FORWARDS_ONE_SEC:    'hotkey:seek-forwards-one-sec',
	HOTKEY_SEEK_BACKWARDS_ONE_FRAME: 'hotkey:seek-backwards-one-frame',
	HOTKEY_SEEK_FORWARDS_ONE_FRAME:  'hotkey:seek-forwards-one-frame',
};

for (let i = 1; i <= 9; i++) {
	events[`HOTKEY_TAG_${i}`] = `hotkey:tag-${i}`;
}

export const allKeyActionsPlay = [
	{ key: 'K', action: events.HOTKEY_TOGGLE_PLAY },
	{ key: ' ', action: events.HOTKEY_TOGGLE_PLAY },
	{ key: 'M', action: events.HOTKEY_TOGGLE_MUTE },
	{ key: '0', action: events.HOTKEY_RESTART_PLAYER },
	{ key: 'F', action: events.HOTKEY_TOGGLE_FULLSCREEN },
];

export const allKeyActionsSeek = [
	{ key: 'J', action: events.HOTKEY_SEEK_BACKWARDS_ONE_SEC },
	{ key: 'L', action: events.HOTKEY_SEEK_FORWARDS_ONE_SEC },
	{ key: ',', action: events.HOTKEY_SEEK_BACKWARDS_ONE_FRAME },
	{ key: '.', action: events.HOTKEY_SEEK_FORWARDS_ONE_FRAME },
];

export const allKeyActionsTabNav = [
	{ key: 'T', action: events.HOTKEY_NEXT_TAB },
	{ key: 'T', shiftKey: true, action: events.HOTKEY_PREVIOUS_TAB },
];

export const viewModeKeyActions = [
	...allKeyActionsPlay,
	...allKeyActionsSeek,
	...allKeyActionsTabNav,
	{ key: 'ARROWLEFT', action: events.HOTKEY_SEEK_BACKWARDS_TEN_SEC },
	{ key: 'ARROWRIGHT', action: events.HOTKEY_SEEK_FORWARDS_TEN_SEC },
	{ key: 'ARROWUP', action: events.HOTKEY_VOLUME_UP },
	{ key: 'ARROWDOWN', action: events.HOTKEY_VOLUME_DOWN },
];

export const couchModeKeyActions = [
	...allKeyActionsPlay,
	...allKeyActionsSeek,
	...allKeyActionsTabNav,
	{ key: 'ARROWLEFT', action: events.HOTKEY_COUCH_SEEK_BACKWARDS },
	{ key: 'ARROWRIGHT', action: events.HOTKEY_COUCH_SEEK_FORWARDS },
	{ key: 'ARROWUP', action: events.HOTKEY_VOLUME_UP },
	{ key: 'ARROWDOWN', action: events.HOTKEY_VOLUME_DOWN },
];

export const viewModeSmartTVNavBackActions = [{ key: 'GOBACK', action: events.HOTKEY_TV_BACK }];

export const analysisKeyActions = [
	...allKeyActionsPlay,
	{ key: 'ARROWUP', action: events.HOTKEY_SPEED_UP },
	{ key: 'ARROWDOWN', action: events.HOTKEY_SPEED_DOWN },
	{ key: 'ARROWLEFT', action: events.HOTKEY_SEEK_BACKWARDS_TEN_SEC },
	{ key: 'ARROWRIGHT', action: events.HOTKEY_SEEK_FORWARDS_TEN_SEC },
	...allKeyActionsSeek,
	...allKeyActionsTabNav,
	{ key: 'I', action: events.HOTKEY_IN_POINT },
	{ key: 'O', action: events.HOTKEY_OUT_POINT },
	{ key: 'E', action: events.HOTKEY_EDIT_NEWEST_TAG },
	{ key: 'P', action: events.HOTKEY_PLAY_LAST_TAG },
];
// 1-9 the most used tag buttons per sport (TBD)
// for (let i = 1; i <= 9; i++) {
// 	analysisKeyActions.push({
// 		key:    i,
// 		action: events[`HOTKEY_TAG_${i}`],
// 	});
// }
